import { useState, useEffect } from "react"
import { Row, Col } from 'antd'
import { useSelector } from "react-redux"
import styled from "styled-components"
import { ImageWithFallback } from "../common/Image"
const StyledBrandInfo = styled(Row)`
    display: flex;
    .brand-info{
        margin-top: 16px;
        display: flex;
        flex-grow:1;
        flex-direction: column;
    }
    .brand-name,
    .brand-device {
        display: flex;
        justify: start;
    }
    .brand-name{
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        @media (max-width: 420px) {
            font-size: 16px;
            line-height: 16px;
        }
    }
    .brand-device {
        color: var(--primary-main-color);
        font-size: 16px;
        line-height: 16px;
        font-weight: 400;
        margin-top: 8px;
        @media (max-width: 420px) {
            margin-top: 4px;
        }
    }
`
const StyledImage = styled(ImageWithFallback)`
    height: 64px;
    width: 64px;
    @media (max-width: 420px) {
        width: 30px;
        height: 40px;
    }
`
const StyledBox = styled.div`
`

const BrandInfo = ({ selector }) => {

    const { rdevice, rbrand } = useSelector(selector)
    const [device, setDevice] = useState()
    const [brand, setBrand] = useState()
    const isReady = () => {
        return device && brand 
    }
    useEffect(() => {
        // console.log(rdevice, rbrand, rmodel, rrepair)
        if (rdevice && rbrand ) {
            setDevice(rdevice)
            setBrand(rbrand)
        }
    }, [rdevice, rbrand])

    const brandName = `${brand?.brand_name} `
    return isReady() && <StyledBrandInfo type="flex" gutter={16} className="brand-info">
        <Col style={{ justifySelf: 'center' }}>
            <StyledImage mainSrc={brand?.brand_image} fallback={device?.device_image} className="brand-image" />
        </Col>
        <Col style={{
            // alignItems: 'center',
            justifyItems: 'flex-start',
            alignSelf: "center",
            justifySelf: 'start',
            display: "flex",
            flexDirection: 'column',
            justifyContent: 'flex-start'
        }}>
            <StyledBox className='brand-name'>
                {brandName}
            </StyledBox>
            <StyledBox className='brand-device'>
                {device.device_name}
            </StyledBox>
        </Col>
    </StyledBrandInfo>
}

export default BrandInfo